import { toTimestamp } from 'common/utils';
import { differenceInMinutes } from 'date-fns';
import { EventRoom, EventRoomApiPayload } from 'domain/event';
import { BackstageRoomApiPayload } from 'store/apis/event';

import { mapToEventRoomAttendeeFromApi } from './mapToEventRoomAttendeeFromApi';

export const mapEventRoomFromApi = (room: EventRoomApiPayload): EventRoom => {
  const { agoraToken, startTime: apiStartTime, endTime: apiEndTime, id, attendees = [] } = room;
  const startTime = toTimestamp(apiStartTime);
  const endTime = toTimestamp(apiEndTime);
  const duration = differenceInMinutes(endTime, startTime, { roundingMethod: 'round' });

  return {
    id,
    accessToken: agoraToken,
    attendees: attendees.map(mapToEventRoomAttendeeFromApi),
    duration,
    endTime,
    startTime,
    orderNumber: -1,
    roomQuestionAssignments: room.roomQuestionAssignments ?? [],
  };
};

// The Backstage snapshot only carries id, endTime, and attendees — agoraToken, startTime, and
// roomQuestionAssignments are delivered later via the room_opened WS replay on JoinMeetingCommand.
export const mapBackstageRoomFromApi = (room: BackstageRoomApiPayload): EventRoom => ({
  id: room.id,
  startTime: 0,
  endTime: toTimestamp(room.endTime),
  duration: 0,
  attendees: room.attendees.map(mapToEventRoomAttendeeFromApi),
  orderNumber: -1,
  roomQuestionAssignments: [],
});
